<div class="detail" [class.hj]="!!highJewelryStockInfo">

  @if(pdp?.isNewIn){<div class="new-in">{{"New"|translate}}</div>}

  <div class="catalog-code">
    {{pdp?.catalogCode}}
    @if(pdp?.equivalentCode){
    &nbsp;||&nbsp;EQ&nbsp;{{pdp?.equivalentCode}}
    }
    &nbsp;|&nbsp;
    {{pdp?.sapCode}}
  </div>

  <div class="aesthetic-line">{{pdp?.aestheticLine}}</div>

  @if(pdp){
  <app-multi-row-text-ellipsis [text]="pdp.description"></app-multi-row-text-ellipsis>
  }

  @if(pdp && pdp.shortDescription){
  <div class="hr"></div>

  <div class="more-detail storytelling">
    <span class="field-name">{{"Short Description"|translate}}</span>
    <app-multi-row-text-ellipsis [text]="pdp!.shortDescription"></app-multi-row-text-ellipsis>
  </div>
  }

  @if(pdp && pdp.storytelling){
  <div class="hr"></div>

  <div class="more-detail storytelling">
    <span class="field-name">{{"Storytelling"|translate}}</span>
    <app-multi-row-text-ellipsis [text]="pdp!.storytelling"></app-multi-row-text-ellipsis>
  </div>
  }

  <div class="hr"></div>

  @if(price === undefined){

  <div class="spinner-wrapper">
    <div class="spinner-border text-primary mx-auto" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  }@else {

  <div class="price-row">

    @if(canShowPrice && price){
    <div class="price">

      @if(includingTaxes){
      <span class="taxes fs-6">{{'Including taxes'|translate}}</span>
      }@else {
      <span class="taxes fs-6">{{'Excluding taxes'|translate}}</span>
      }

      <div class="price-label">
        {{priceLabel}}
      </div>

    </div>
    }

    @if(canShowPriceListButton){
    <button class="btn btn-link dropdown-toggle" role="button" (click)="showPriceList()">
      {{"PRICE LIST"|translate}}
      <i class="bi bi-chevron-down"></i>
    </button>
    }

  </div>
  }

  <div class="buttons-row placeholder-glow">

    @if(canShowSizeList){
    <button class="detail-btn btn btn-light" (click)="showSizeList()">
      <span>{{"Size"|translate}}</span>
      <span>{{selectedSize()?.size ?? ''}}</span>
      <span>{{"Select Size"|translate}}</span>
      <img src="assets/icons/arrow-down.svg" alt="">
    </button>
    }

    @if(canShowColorList){
    <button class="detail-btn btn btn-light stock" (click)="showColorList()">
      <span>{{"Select Color"|translate}}</span>
      <img src="assets/icons/arrow-down.svg" alt="">
    </button>
    }

    @if(!highJewelryStockInfo){

    @if(canShowViewStock && pdp?.isBatchManaged){

    <button class="detail-btn btn btn-light" [class.placeholder]="showStockLoader() && shouldShowLoaderViewStockButton"
      [disabled]="showStockLoader() && shouldShowLoaderViewStockButton" (click)="viewStock.emit()">
      <span>{{"Size"|translate}}</span>
      <span>{{selectedSize()?.size}}</span>
      <span></span>
      <span>{{"More Sizes"|translate}}</span>
      <img src="assets/icons/arrow-down.svg" alt="">
    </button>

    }@else{

    @if(canShowViewStock && !isHighJewelry){

    <button class="detail-btn btn btn-light stock"
      [class.placeholder]="showStockLoader() && shouldShowLoaderViewStockButton"
      [disabled]="showStockLoader() && shouldShowLoaderViewStockButton" (click)="viewStock.emit()">
      <span>{{"View Stock"|translate}}</span>
      <img src="assets/icons/arrow-down.svg" alt="">
    </button>

    }

    }

    }

    @if(isHighJewelry){

    @if(highJewelryStockInfo){

    <div class="info" [class.placeholder]="showStockLoader()" (click)="null">
      <span>{{"Company Current Location"|translate}}</span>
      <span>{{highJewelryStockInfo.currentCompanyDescription || 'N/A'}}</span>
    </div>

    <div class="info" [class.placeholder]="showStockLoader()" (click)="null">
      <span>{{"Current Location Description"|translate}}</span>
      <span>{{highJewelryStockInfo.currentStoreDescription || 'N/A'}}</span>
    </div>

    @if(highJewelryStockInfo.isBookedForSale){
    <div class="info bfs" (click)="null">
      <span>{{"Status"|translate}}</span>
      <span>{{"Booked For Sales"|translate}}</span>
    </div>
    }

    }@else {

    <div class="info" [class.placeholder]="true" (click)="null">
      <span>{{"Company Current Location"|translate}}</span>
      <span></span>
    </div>

    <div class="info" [class.placeholder]="true" (click)="null">
      <span>{{"Current Location Description"|translate}}</span>
      <span></span>
    </div>

    }

    }


  </div>

  @if(pdp){
  <div class="more-details accordion">
    <div class="accordion-item">

      <div class="accordion-header">
        <button class="accordion-button" [class.collapsed]="isMoreDetailsAccordionCollapsed()" type="button"
          aria-expanded="false" (click)="toggle()">
          {{"More Details"|translate}}
        </button>
      </div>

      <div #moreDetailsAccordion class="accordion-collapse collapse">
        <div class="accordion-body">

          @for(detail of pdp.details; track detail.fieldName){

          @switch (true) {

          @case(detail.fieldName.toLowerCase() === "storytelling"){}

          @case(detail.fieldName.toLowerCase() === "digitalpassport"){}

          @case(detail.fieldName.toLowerCase() === "plmshineforleather" || detail.fieldName.toLowerCase() ===
          "plmbagspa"){
          <div class="more-detail">
            <span class="field-name">{{`pdp.more-details.${detail.fieldName}`|translate}}</span>
            <span class="value">{{getYesOrNoText(detail.value)}}</span>
          </div>
          }

          @case(detail.value && detail.value.length > 200){
          <div class="more-detail lg">
            <span class="field-name">{{`pdp.more-details.${detail.fieldName}`|translate}}</span>
            <span class="value">{{detail.value}}</span>
          </div>
          }

          @default {
          <div class="more-detail">
            <span class="field-name">{{`pdp.more-details.${detail.fieldName}`|translate}}</span>
            <span class="value">{{detail.value}}</span>
          </div>
          }

          }

          }

        </div>
      </div>
    </div>
  </div>

  @if(parure && parure.length > 0){
  <div class="parure">
    <div class="title">
      {{"pdp.parure.title"|translate}}
      <button class="btn btn-rounded btn-light" data-toggle="tooltip" data-placement="right"
        [title]="'pdp.parure.description'|translate">
        <img src="assets/icons/i.svg" alt="">
      </button>
    </div>
    <div class="products">
      @for(product of parure; track product.sapCode){
      <app-product [product]="product" [overrideCallback]="(handleProductClick).bind(this)"
        [isInSearchPage]="true"></app-product>
      }
    </div>
  </div>
  }
  }

</div>

<app-price-list-modal #priceListModal></app-price-list-modal>
<app-size-list-modal #sizeListModal (handleSelectSize)="handleSelectSize($event)"></app-size-list-modal>
<app-color-list-modal #colorListModal (handleSelectColor)="handleSelectColor($event)"></app-color-list-modal>
